import { render, staticRenderFns } from "./AllProds.vue?vue&type=template&id=028cec98"
import script from "./AllProds.vue?vue&type=script&lang=js"
export * from "./AllProds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports